import {createContext} from 'react'

export type BuildProblemsTreeContextType = {
  getEndpoint: (locator: string) => string
  locatorInEndpoint: boolean
  subTreeRootIdInLocator?: boolean
}

export const buildProblemsTreeContextDefaultValue = {
  getEndpoint: () => 'problemOccurrences/tree',
  locatorInEndpoint: false,
  subTreeRootIdInLocator: true,
}

export const BuildProblemsTreeContext = createContext<BuildProblemsTreeContextType>(
  buildProblemsTreeContextDefaultValue,
)
